import { render, staticRenderFns } from "./InputPhoneNumber.vue?vue&type=template&id=525c4aa6&scoped=true&"
import script from "./InputPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./InputPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./InputPhoneNumber.vue?vue&type=style&index=0&id=525c4aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c4aa6",
  null
  
)

export default component.exports